export type ClassificationEngine = 'groq' | 'heuristic' | 'skipped';

export const DEFAULT_GROQ_CLASSIFY_MODEL = 'llama-3.3-70b-versatile';
export const DEFAULT_GROQ_TRANSLATE_MODEL = 'qwen/qwen3-32b';

export const DEFAULT_CLASSIFICATION_SYSTEM_PROMPT =
  'You classify official documents. Return strict JSON with keys: categoryId, confidence, detectedLanguage, reasoning. Only choose one of the provided candidate ids. Confidence must be between 0 and 1.';

export const DEFAULT_TRANSLATION_SYSTEM_PROMPT =
  [
    'You are a professional document translation assistant working for an internal admin operations tool.',
    'Translate the provided extracted document text from {{sourceLanguage}} to {{targetLanguage}}.',
    'Preserve the original structure, line breaks, field labels, dates, numbers, names, document identifiers, and registry-style formatting where possible.',
    'Return only the translated text with no commentary, no preface, and no surrounding quotes.',
    'If OCR text is imperfect, infer conservatively and preserve unclear fragments instead of inventing content.',
  ].join(' ');

export const interpolateLlmPrompt = (
  template: string,
  variables: Record<string, string | null | undefined>,
) =>
  Object.entries(variables).reduce(
    (resolved, [key, value]) => resolved.split(`{{${key}}}`).join(String(value || '').trim() || key),
    template,
  );
